import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { AssetResponse } from '../services/api';
import { FundamentalScoresContent } from '../services/api/fundamental-scores';

interface WorkflowAssetState {
  isin: string | null;
  v2Data: AssetResponse | null;
  fundamentalScores: FundamentalScoresContent | null;
  loading: boolean;
  error: string | null;
}

const initialState: WorkflowAssetState = {
  isin: null,
  v2Data: null,
  fundamentalScores: null,
  loading: false,
  error: null,
};

export const AssetsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    startLoading(isin: string) {
      patchState(store, {
        isin,
        v2Data: null,
        fundamentalScores: null,
        loading: true,
        error: null,
      });
    },

    setV2Data(data: AssetResponse) {
      patchState(store, {
        v2Data: data,
        loading: false,
        error: null,
      });
    },

    setFundamentalScores(data: FundamentalScoresContent | null) {
      patchState(store, { fundamentalScores: data });
    },

    setError(error: string) {
      patchState(store, {
        loading: false,
        error,
      });
    },

    reset() {
      patchState(store, initialState);
    },
  })),
);
